import { render, staticRenderFns } from "./Roads_Details.vue?vue&type=template&id=59fa1ac4&scoped=true"
import script from "./Roads_Details.vue?vue&type=script&lang=js"
export * from "./Roads_Details.vue?vue&type=script&lang=js"
import style0 from "./Roads_Details.vue?vue&type=style&index=0&id=59fa1ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fa1ac4",
  null
  
)

export default component.exports